import { Select } from '@mantine/core';
import classes from './styles.module.css';
import useEventsTrailSlice, { DEFAULT_MODULE_ID } from '@/store/homeWidget/useEventsTrailSlice';
import { useTranslation } from 'react-i18next';
import { IconChevronDown } from '@tabler/icons';

export function FilterTable() {
  const [filter, setFilter] = useEventsTrailSlice().useFilters().useState();
  const [commonSettings] = useEventsTrailSlice().useEvents().useState();

  const onChange = (module: string | null) => {
    setFilter((prev) => ({
      ...prev,
      module: module || ''
    }));
  };

  const priorities = commonSettings?.UserActionPriority || [];
  const { t } = useTranslation();

  const moduleOptions = priorities.reduce(
    (acc: { value: string; label: string }[], p) => {
      const hasPriority = acc.find((i) => i.value === p.ModuleName);
      if (!hasPriority) {
        acc.push({
          value: p.ModuleName,
          label: p.ModuleName
        });

        return acc;
      }

      return acc;
    },
    [
      {
        value: DEFAULT_MODULE_ID,
        label: t('filials.settings.allModules')
      }
    ]
  );

  return (
    <Select
      rightSection={<IconChevronDown size="1rem" color="#98A2B3" />}
      placeholder={t('filials.settings.searchByName')}
      className={classes.select}
      value={filter.module}
      onChange={onChange}
      data={moduleOptions}
      comboboxProps={{ transitionProps: { transition: 'pop', duration: 200 } }}
    />
  );
}
